import { stateList } from "service/constant";
import { SelectInput } from "../UI/Select";
import { useTranslation } from "react-i18next";

const StateSelect = () => {
  const { t } = useTranslation("form");
  return (
    <SelectInput
      label={t("state")}
      placeholder={t("state")}
      id="state"
      autoComplete="state"
      required={true}
      helperText={null}
      optionList={stateList}
    />
  );
};

export default StateSelect;